/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ business: NonNullable<unknown> }} Booking_Portal_Prepay_AskInputs */

const en_booking_portal_prepay_ask = /** @type {(inputs: Booking_Portal_Prepay_AskInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.business} will tell you how to pay.`)
};

const pl_booking_portal_prepay_ask = /** @type {(inputs: Booking_Portal_Prepay_AskInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.business} przekaże, jak zapłacić.`)
};

/**
* | output |
* | --- |
* | "{business} will tell you how to pay." |
*
* @param {Booking_Portal_Prepay_AskInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const booking_portal_prepay_ask = /** @type {((inputs: Booking_Portal_Prepay_AskInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Booking_Portal_Prepay_AskInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_booking_portal_prepay_ask(inputs)
	return en_booking_portal_prepay_ask(inputs)
});